import { render } from "./DiscussionModal.vue?vue&type=template&id=e768281c&scoped=true"
import script from "./DiscussionModal.vue?vue&type=script&lang=js"
export * from "./DiscussionModal.vue?vue&type=script&lang=js"

import "./DiscussionModal.vue?vue&type=style&index=0&id=e768281c&lang=sass&scoped=true"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e768281c"]])

export default __exports__